import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dataLabel break-word" }

import {computed} from "vue";
import moment from "moment/moment";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";


interface Props {
  value?: any
  valueType?: SogDataLabelValueType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogDataLabel',
  props: {
    value: { default: undefined },
    valueType: { default: undefined }
  },
  setup(__props: any) {

const props = __props

/*
defineProps({
  value: any,
  valueType: String as PropType<ValueType>
})
*/

const valueString = computed(() => {
  if (props.value || props.value === 0) {
    if (props.valueType === SogDataLabelValueType.DateTime) {
      return moment(props.value).format("DD.MM.YYYY HH:mm:ss");
    } else if (props.valueType === SogDataLabelValueType.Date) {
      return moment(props.value).format("DD.MM.YYYY");
    } else if (props.valueType === SogDataLabelValueType.Money && props.value) {
      const val = props.value
      return Number(val).toLocaleString("de-DE", {style: 'currency', currency: 'EUR'});
    }
    return props.value
  }
  return "";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(valueString.value), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})